import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'svg[mib-close-icon]',
  template: `
    <svg:path
      d="M3.59375 3.59375L3.70312 3.51562L3.8125 3.45312L3.9375 3.42188L4.0625 3.40625L4.1875 3.42188L4.3125 3.45312L4.42188 3.51562L4.53125 3.59375L8 7.07812L11.5156 3.54688L11.625 3.48438L11.75 3.4375L11.875 3.40625H12L12.125 3.4375L12.2344 3.48438L12.3438 3.54688L12.4375 3.64062L12.5156 3.75L12.5625 3.875L12.5938 4V4.125L12.5625 4.25L12.5156 4.375L12.4375 4.48438L8.92188 8L12.4531 11.5156L12.5156 11.625L12.5625 11.75L12.5938 11.875V12L12.5625 12.125L12.5156 12.25L12.4531 12.3594L12.3594 12.4531L12.25 12.5156L12.125 12.5625L12 12.5938H11.875L11.75 12.5625L11.625 12.5156L11.5156 12.4531L8 8.92188L4.48438 12.4531L4.375 12.5156L4.25 12.5625L4.125 12.5938H4L3.875 12.5625L3.75 12.5156L3.64062 12.4531L3.54688 12.3594L3.48438 12.25L3.4375 12.125L3.40625 12V11.875L3.4375 11.75L3.48438 11.625L3.54688 11.5156L7.07812 8L3.54688 4.48438L3.48438 4.375L3.4375 4.25L3.40625 4.125V4L3.4375 3.875L3.48438 3.75L3.54688 3.64062L3.59375 3.59375Z" />
  `,
  host: {
    '[attr.viewBox]': 'viewBox()',
    class: 'mib-icon-default-size fill-current transition-colors',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseIcon {
  readonly viewBox = input<string>('0 0 16 16');
}
